import { concatStyles } from '@styles/domain';
import { type ElementType, type FC, type HTMLAttributes } from 'react';
import * as styles from './index.css';

type Variant = keyof typeof styles.variants;

const DEFAULT_TAG: Record<Variant, ElementType> = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'span',
  body2: 'span',
  body3: 'span',
};

interface Props extends HTMLAttributes<HTMLElement> {
  variant?: Variant;
  as?: ElementType;
}

const Typography: FC<Props> = ({
  variant = 'body2',
  as,
  className,
  ...rest
}) => {
  const Tag = as ?? DEFAULT_TAG[variant];
  return (
    <Tag
      className={concatStyles([styles.variants[variant], className])}
      {...rest}
    />
  );
};

export default Typography;
